// extracted by css-extract-rspack-plugin
export default {"cls1":"HeroWorkCardHeader-cls1_RRX","cls2":"HeroWorkCardHeader-cls2_KMJ HeroWorkCardHeader-cls1_RRX"};